<div class="flex flex-col gap-4">

  <mat-card class="portal-page-heading mb-2" *ngIf="!assigned && licenseId === 0">
    <mat-card-content>
      <div class="flex flex-row justify-start items-center gap-4">

        <mat-icon class="portal-heading-icon" aria-hidden="true" fontIcon="home_health"></mat-icon>
        <h1 class="portal-page-title">Manage In Home Care Changes</h1>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="flex flex-col" *ngIf="change.id === 0">
    <div class="flex flex-col" *ngIf="licenseId === 0">
      <span class="text-xl font-semibold" *ngIf="assigned">My Assigned Changes</span>
      <div class="flex flex-col md:flex-row gap-4 items-center portal-actions" *ngIf="!assigned">
        <mat-checkbox [(ngModel)]="includeApproved" labelPosition="before">
          <span>Include Approved</span>
        </mat-checkbox>
        <mat-checkbox [(ngModel)]="includeDenied" labelPosition="before">
          <span>Include Denied</span>
        </mat-checkbox>
        <button type="button" mat-raised-button color="primary" (click)="getChanges()">Refresh</button>
      </div>

      <div class="flex flex-row pt-4 portal-field-grid">
        <mat-form-field class="w-1/4">
          <input matInput (keyup)="filterChanges($event)" placeholder="Filter By License" />
        </mat-form-field>
      </div>
    </div>

    <mat-table [dataSource]="changeSource" matSort #changeSort="matSort" aria-describedby="In Home Care Changes" class="mat-elevation-z8 portal-responsive-table">
      <ng-container matColumnDef="licenseGuid">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">License</mat-header-cell>
        <mat-cell tabindex="0" (click)="selectChange(change)" *matCellDef="let change" (keydown.enter)="$event.target === $event.currentTarget && (selectChange(change))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectChange(change))">
          <span class="mobile-label">License</span>
          {{ change.licenseGuid }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="entityName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Name</mat-header-cell>
        <mat-cell tabindex="0" (click)="selectChange(change)" *matCellDef="let change" (keydown.enter)="$event.target === $event.currentTarget && (selectChange(change))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectChange(change))">
          <span class="mobile-label">Name</span>
          {{ change.entityName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="agencyDBAName">
        <mat-header-cell *matHeaderCellDef mat-sort-header=""><abbr title="Doing Business As">DBA</abbr></mat-header-cell>
        <mat-cell tabindex="0" (click)="selectChange(change)" *matCellDef="let change" (keydown.enter)="$event.target === $event.currentTarget && (selectChange(change))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectChange(change))">
          <span class="mobile-label"><abbr title="Doing Business As">DBA</abbr></span>
          {{ change.agencyDBAName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="city">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">City</mat-header-cell>
        <mat-cell tabindex="0" (click)="selectChange(change)" *matCellDef="let change" (keydown.enter)="$event.target === $event.currentTarget && (selectChange(change))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectChange(change))">
          <span class="mobile-label">City</span>
          {{ change.city }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Request</mat-header-cell>
        <mat-cell tabindex="0" (click)="selectChange(change)" *matCellDef="let change" (keydown.enter)="$event.target === $event.currentTarget && (selectChange(change))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectChange(change))">
          <span class="mobile-label">Request</span>
          {{ change.type }}
          {{ sharedService.readableEntityTypes[change.entity] }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="approved">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Status</mat-header-cell>
        <mat-cell tabindex="0" (click)="selectChange(change)" *matCellDef="let change" (keydown.enter)="$event.target === $event.currentTarget && (selectChange(change))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectChange(change))">
          <span class="mobile-label">Status</span>
          <span *ngIf="change.approved">Approved</span>
          <span *ngIf="change.denied">Denied</span>
          <span *ngIf="!change.approved && !change.denied">Pending</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="effectiveDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Effective Date</mat-header-cell>
        <mat-cell tabindex="0" (click)="selectChange(change)" *matCellDef="let change" (keydown.enter)="$event.target === $event.currentTarget && (selectChange(change))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectChange(change))">
          <span class="mobile-label">Effective</span>
          {{ change.effectiveDateOfChange | date }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="assignedToName">
        <mat-header-cell *matHeaderCellDef>Assigned To</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let change">
          <span class="mobile-label">Assigned</span>
          <mat-form-field style="margin-top: 0.25em; margin-bottom: -1em; height: 50pt;">
            <mat-select [(value)]="change.assignedToName" (selectionChange)="assignChange($event, change.id)">
              <mat-option>-- None --</mat-option>
              <mat-option *ngFor="let staff of staff" value={{staff.name}}>{{staff.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="changeColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: changeColumns"
               class=""
               [ngClass]="row.archived? 'portal-archived' : ''"></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[20, 50, 100]" #changePaginator="matPaginator">
    </mat-paginator>

    <app-entity-task [entityType]="sharedService.inHomeCareLicense" *ngIf="licenseId === 0 && !assigned"></app-entity-task>
  </div>

  <div *ngIf="change.id > 0" class="flex flex-col gap-4" [@slideRight]>
    <div class="flex flex-row items-center portal-actions">
      <span class="text-xl font-semibold">Request to {{change.type}} {{sharedService.readableEntityTypes[change.entity]}} for {{change.licenseGuid}}</span>
      <button class="ml-auto" mat-raised-button color="warn" (click)="close()">Close</button>
    </div>

    <div [ngClass]="change.entity !== sharedService.administratorApplication? 'flex flex-col md:flex-row gap-4' : 'flex flex-col'">
      <div class="flex flex-col" [ngClass]="change.entity !== sharedService.administratorApplication? 'md:w-1/2' : ''">
        <!--
          Change Entity Owner
        -->
        <div class="flex flex-col gap-4" *ngIf="change.entity === sharedService.entityOwner">
          <div class="flex flex-col font-semibold text-xl" *ngIf="change.type === sharedService.delete">
            Request to remove {{owner.firstName}} {{owner.lastName}} as an owner of the agency.
          </div>

          <mat-card>
            <mat-card-content>
              <entity-owner *ngIf="change.type !== sharedService.delete"
                            [entityId]="change.id"
                            [entityType]="sharedService.inHomeCareChange"
                            [isChange]="true">
              </entity-owner>
            </mat-card-content>
          </mat-card>

          <div class="flex flex-col md:flex-row portal-section-grid" *ngIf="change.type === sharedService.change && change.subunits.length > 0">
            <div class="flex flex-col md:w-1/2">
              <span class="font-semibold text-lg">Subunits being transferred</span>
              <div *ngFor="let subunit of change.subunits">{{subunit}}</div>
            </div>
            <div class="flex flex-col md:w-1/2" *ngIf="change.newParent">
              <span class="font-semibold text-lg">New Parent</span>
              <span>{{change.newParent}}</span>
            </div>
          </div>
        </div>

        <!--
          Change Administrator
        -->
        <div class="flex flex-col gap-4" *ngIf="change.entity === sharedService.administratorApplication">
          <administrator-application [entityId]="change.id"
                                     [entityType]="sharedService.inHomeCareChange">
          </administrator-application>
        </div>

        <!--
          Set As Parent Agency
        -->
        <div class="flex flex-col" *ngIf="change.entity === sharedService.parent">
          <div class="flex flex-row gap-2">
            <span class="md:w-1/6">Current Parent Agency</span>
            <span class="font-semibold">{{change.originalValue}}</span>
          </div>
          <div class="flex flex-row gap-2">
            <span class="md:w-1/6">New Parent Agency</span>
            <span class="font-semibold">{{change.newValue}}</span>
          </div>

        </div>

        <!--
          Change Branch Operation
        -->
        <div class="flex flex-col" *ngIf="change.entity === sharedService.branchOperation">
          <div class="flex flex-col gap-2" *ngIf="change.type === sharedService.add">
            <branch-operation *ngIf="change.entity === sharedService.branchOperation"
                              [entityId]="change.id"
                              [entityType]="sharedService.inHomeCareChange">
            </branch-operation>
          </div>

          <div class="flex flex-col gap-2" *ngIf="change.type === sharedService.change">
            <span>Current Address</span>
            <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
              <span class="font-semibold">{{address.street}}</span>
              <span class="font-semibold">{{address.city}}, {{address.state}} {{address.zip}}</span>
              <span class="font-semibold">{{address.county}}</span>
            </div>

            <span class="pt-4">New Address</span>
            <address class="mt-4"
                      [entityId]="change.id"
                      [entityType]="sharedService.inHomeCareChange"></address>
          </div>
        </div>

        <!--
          Change Classification
        -->
        <div class="flex flex-col" *ngIf="change.entity === sharedService.classification">
          <div class="flex flex-row gap-2">
            <span class="md:w-1/4">Current classification</span>
            <span class="font-semibold">{{change.originalValue}}</span>
          </div>
          <div class="flex flex-row gap-2">
            <span class="md:w-1/4">New classification</span>
            <span class="font-semibold">{{change.newValue}}</span>
          </div>
        </div>

        <!--
          Change Nurse
        -->
        <div class="flex flex-col" *ngIf="change.entity === sharedService.nurse">
          <div class="flex flex-row gap-2">
            <span class="md:w-1/12">Current Nurse</span>
            <span class="font-semibold">{{change.originalValue}}</span>
          </div>
          <div class="flex flex-row gap-2">
            <span class="md:w-1/12">New Nurse</span>
            <span class="font-semibold">{{change.newValue}}</span>
          </div>
        </div>

        <!--
          Change Address
        -->
        <div class="flex flex-col gap-2" *ngIf="change.entity === sharedService.address">
          <span>Current Address</span>
          <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row" *ngIf="address.id > 0">
            <span class="font-semibold">{{address.street}}</span>
            <span class="font-semibold">{{address.city}}, {{address.state}} {{address.zip}}</span>
            <span class="font-semibold">{{address.county}}</span>
          </div>

          <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row" *ngIf="address.id === 0">
            <span class="font-semibold">No Current Address Recorded</span>
          </div>

          <span class="pt-4">Requested Address</span>
          <address class="mt-4"
                    [entityId]="change.id"
                    [entityType]="sharedService.inHomeCareChange"></address>
        </div>

        <!--
          Status
        -->
        <div class="flex flex-col gap-4 pt-4">

          <div class="flex flex-col md:flex-row gap-4 portal-field-grid">
            <div class="flex flex-col md:w-1/2">
              <span class="font-semibold">Status</span>
              <span>{{change.approved? 'Approved' : change.denied? 'Denied' : 'Pending'}}</span>
            </div>
          </div>

          <div class="flex flex-col md:flex-row gap-4 portal-field-grid" *ngIf="change.entity !== sharedService.entityOwner || change.type !== sharedService.change">
            <div class="flex flex-col md:w-1/2">
              <span class="font-semibold">Administrator Signaure</span>
              <span>{{change.signature}}</span>
            </div>

            <div class="flex flex-col">
              <span class="font-semibold">Title</span>
              <span>{{change.title}}</span>
            </div>
          </div>

          <div class="flex flex-col md:flex-row gap-4 portal-section-grid">
            <div class="flex flex-col md:flex-row md:w-1/2 gap-2 items-center portal-actions">
              <div class="flex flex-col gap-2">
                <span class="font-semibold">Effective Date</span>
                <mat-form-field>
                  <input placeholder="mm/dd/yyyy" [(ngModel)]="effectiveDate" matInput [matDatepicker]="effectiveDatePicker" />
                  <mat-datepicker-toggle matSuffix [for]="effectiveDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #effectiveDatePicker>
                    <mat-datepicker-actions>
                      <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                      <button mat-button matDatepickerCancel>Cancel</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </mat-form-field>
              </div>

              <button type="button" mat-flat-button color="primary" (click)="updateEffectiveDate()">
                Update
              </button>
            </div>

            <div class="flex flex-col" *ngIf="change.entity !== sharedService.entityOwner || change.type !== sharedService.change">
              <span class="font-semibold">Date Signed</span>
              <span>{{change.dateSigned | date}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col md:w-1/2 gap-4">
        <document *ngIf="change.entity === sharedService.classification || change.entity === sharedService.entityOwner"
                  [entityId]="change.id"
                  [entityType]="sharedService.inHomeCareChange">
        </document>
        <notes [entityId]="change.id"
               [entityType]="sharedService.inHomeCareChange">
        </notes>
      </div>
    </div>

    <app-manage-payments *ngIf="change.requiresPayment"
      class="w-3/4"
      [entityId]="change.licenseId.toString()"
      [entityType]="sharedService.inHomeCareLicense"
      [allowMultiplePayments]="true"
      [allowDelete]="false"
      [editingPayment]="true"
      [sku]="change.entity === sharedService.entityOwner ? skus.Owner : skus[change.originalValue + change.newValue]">
    </app-manage-payments>

    <div class="flex flex-col md:flex-row md:gap-4 portal-actions" *ngIf="canApprove && !change.approved && !change.denied">
      <button type="button" mat-raised-button color="primary" (click)="approveChange(true)">Approve</button>
      <button type="button" mat-raised-button color="warn" (click)="approveChange(false)">Deny</button>
      <button mat-raised-button color="warn" (click)="close()">Close</button>
    </div>

  </div>
</div>
